module.exports = __webpack_public_path__ + "static/media/MiKLogo_hr.201799af.png";